export const CUSTOMER_SUPPORT = "+91-1204814491"; 
export const MAIN_WEBSITE = "https://partners.travomint.co/";
export const EMAIL_WEB = "cs@travomint.com";
export const SUPPORT_EMAIL = "customer.support@travomint.co"
export const COMPANY_NAME = "SNVA TRAVEL TECH";
export const SNVA_INFO = {
 companyName : COMPANY_NAME,
 companyAddress : "B-28 & 29, Sector 58, Noida Uttar Pradesh, 201301, India",
 companyPhone : CUSTOMER_SUPPORT,
 companyEmail : EMAIL_WEB,
 GSTIN :  "U63030UP2017PTC089611", 
}

export const defaultBankDetails = {
  accountNumber: "10204145678",
  beneficiaryName: COMPANY_NAME,
  ifscCode: "IDFB0020152",
  bankName: "IDFC FIRST BANK",
  accountType: "Current Account",
//   branchName: "Main Branch",
  branchLocation: "SECTOR 45 NOIDA",
};